const optlyEvents = {
  orderSubmitted: 'order_submitted',
  orderStarted: 'order_started',
  engagedOrderStarted: 'engaged_order_started',
  engagedOrderSubmitted: 'engaged_order_submitted',
  contractExpiryDateSubmitted: 'contract_expiry_date_submitted',
};

export { optlyEvents };
